import React from "react";

import cancelButton from "../../assets/icons/Cancel-16px-Black-100.svg"

import './TemplateHeader.scss'

const TemplateHeader = (props) => {

    const { heading, subHeading, onClose } = props;

    return (
        <div className="template-header">
            {
                (onClose) &&
                <img className="cancel-button" onClick={onClose} src={cancelButton} />
            }
            {
                heading &&
                <h4 className="heading">{heading}</h4>
            }
            {
                subHeading &&
                <h3 className="sub-heading">{subHeading}</h3>
            }
        </div>
    );
}

export default TemplateHeader;